import SearchListPage from './src/search-list-page.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpSearchListPage = withInstall(SearchListPage)
export default EpSearchListPage
export type SearchListPageInstance = InstanceType<typeof SearchListPage>
export * from './src/search-list-page'
